import Commerce from '@chec/commerce.js';

const commerce = new Commerce("pk_test_317803f17fdecb5a08be26f5ee0ef1401ae1809386c62", true);

export default commerce;